/** Auth lifecycle coordinator — prevents false logout during login/hydration races (iPad Safari). */

export const AUTH_PHASE = {
  HYDRATING: "hydrating",
  LOGGING_IN: "loggingIn",
  AUTHENTICATED: "authenticated",
  REFRESHING: "refreshing",
  UNAUTHENTICATED: "unauthenticated",
  NETWORK_ERROR: "networkError",
};

let generation = 0;
let loginGraceUntil = 0;
let phase = AUTH_PHASE.HYDRATING;
const LOGIN_GRACE_MS = 8000;

export function getAuthPhase() {
  return phase;
}

export function setAuthPhase(next) {
  phase = next;
}

export function getGeneration() {
  return generation;
}

export function beginLogin() {
  generation += 1;
  phase = AUTH_PHASE.LOGGING_IN;
  loginGraceUntil = Date.now() + LOGIN_GRACE_MS;
  return generation;
}

export function extendLoginGrace() {
  loginGraceUntil = Date.now() + LOGIN_GRACE_MS;
}

export function isInLoginGrace() {
  return Date.now() < loginGraceUntil;
}

export function isGenerationCurrent(token) {
  return token === generation;
}

export function markAuthenticated() {
  phase = AUTH_PHASE.AUTHENTICATED;
  extendLoginGrace();
}

export function markUnauthenticated() {
  phase = AUTH_PHASE.UNAUTHENTICATED;
}

export function markHydrating() {
  phase = AUTH_PHASE.HYDRATING;
}

export function markRefreshing() {
  phase = AUTH_PHASE.REFRESHING;
}

export function markNetworkError() {
  phase = AUTH_PHASE.NETWORK_ERROR;
}

export function isDefinitiveAuthFailure(error) {
  const status = error?.response?.status;
  return status === 401 || status === 403;
}

export function shouldForceLogoutOnRefreshFailure(error) {
  if (isInLoginGrace()) return false;
  return isDefinitiveAuthFailure(error);
}

export function resetAuthSessionCoordinatorForTests() {
  generation = 0;
  loginGraceUntil = 0;
  phase = AUTH_PHASE.HYDRATING;
}
